import { format, isThisYear, isToday, isYesterday } from 'date-fns'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const getDateFormat = ({
  date,
  short,
}: {
  date: Date | number | { _nanoseconds: number; _seconds: number }
  short?: boolean
}) => {
  let originalDate = date

  if (!date) return ''

  // Validate if date is object
  if (
    typeof date === 'object' &&
    '_seconds' in date &&
    '_nanoseconds' in date
  ) {
    originalDate = date._seconds * 1000
  }

  // validate if date is number and if it needs to be multiplied by 1000
  if (typeof date === 'number') {
    if (date.toString().length === 10) {
      originalDate = date * 1000
    }
  }

  if (typeof originalDate !== 'string' && typeof originalDate !== 'number') {
    console.log('Error:', originalDate)
    return ''
  }

  const newDate = new Date(originalDate)
  const month = monthNames[newDate.getMonth()]
  const day = newDate.getDate()
  const year = newDate.getFullYear()

  if (short) return `${month.slice(0, 3)} ${day}, ${year}`

  return `${month} ${day}, ${year}`
}

export const formatDateChat = (date: Date | number) => {
  const newDate = new Date(date)

  if (isToday(newDate)) {
    return format(newDate, 'p')
  }

  if (isYesterday(newDate)) {
    return 'Yesterday'
  }

  if (isThisYear(newDate)) {
    return format(newDate, 'MMM d')
  }

  return format(newDate, 'MM/dd/yyyy')
}

export const getDateFormatMMDDYYYY = (
  date: number | { _seconds: number; _nanoseconds: number }
) => {
  const newDate =
    typeof date === 'number' ? new Date(date) : new Date(date._seconds * 1000)

  return format(newDate, 'MM/dd/yyyy')
}

export const getDateFormatMMMD = (
  data: number | { _seconds: number; _nanoseconds: number }
) => {
  const newDate =
    typeof data === 'number' ? new Date(data) : new Date(data._seconds * 1000)

  return format(newDate, 'MMM d')
}
